import React, { useState } from "react";
import { getMyHotelDetailAsync } from "../../../../features/allBookingSlice";
import {
  IsotoSimpleDate,
  TranferDateFormatter,
} from "../../../../helpers/helper";
import { useSelector } from "react-redux";
import { shallowEqual } from "react-redux";
import moment from "moment";
import Ratings from "../../../UI/Ratings";

const HotelDetail = ({ hotel, dispatch, Authorization, forDelete }) => {
  React.useEffect(() => {
    dispatch(getMyHotelDetailAsync({ Authorization, id: hotel.id }));
  }, []);
  let RoomType;

  const { setShow, setModalData, setDeleting } = forDelete || {};

  const myDetails = useSelector(
    (state) => state.allBookings.singleHotelDetail,
    shallowEqual
  );

  const [amenitiesLimit, setamenitiesLimit] = useState(3);
  const [LimitText, setLimitText] = useState("View all Amenities");

  const amenitiesHanlder = (num, type) => {
    if (type !== "View Less") {
      setamenitiesLimit(num);
      setLimitText("View Less");
    } else {
      setamenitiesLimit(3);
      setLimitText("View all Amenities");
    }
  };

  const LimitStyle = {
    height: "350px",
    overflowY: "scroll",
  };

  const NolimitStyle = {
    overflowY: "none",
    height: "auto",
  };

  const mapHandler = (cor) => {
    var lat = cor.split("|")[0];
    var long = cor.split("|")[1];
    window.open(
      `https://www.google.com/maps/search/?api=1&query=${lat},${long}&z=15`,
      "_blank"
    );
  };
  var i = 1;

  let arr = [];

  //   var divStart = '<div className="room-guest-details">';
  //   var divEnd = "</div>";
  if (Object?.keys(myDetails)?.length > 0) {
    return (
      <>
        <div className="row">
          <div className="col-lg-12 p-0">
            <div className="title">
              <h4>Hotel Booking Details</h4>
            </div>
          </div>
          <div className="col-lg-6 col-md-6">
            <div>
              <h6>Hotel Details</h6>
              <div className="hotel-details-main">
                <div className="hotel-details-wrap d-flex align-items-center w-100">
                  <div className="hotel-details-wrap-img">
                    {hotel?.Hotel_Master?.Hotel_Images?.length > 0 ? (
                      <img
                        src={hotel?.Hotel_Master?.Hotel_Images?.[0]?.image}
                        alt={myDetails.Hotel_Master.name}
                      />
                    ) : (
                      <img
                        src="assets/images/hotelStatic.png"
                        alt={myDetails.Hotel_Master.name}
                      />
                    )}
                  </div>
                  <div className="hotel-details-wrap-star mt-0">
                    <h6 className="mb-0">{myDetails.Hotel_Master.name}</h6>
                    <div className="star-wrap">
                      <Ratings num={myDetails.Hotel_Master.rating} />
                    </div>
                  </div>
                </div>
                <p className="black-medium-12 mt-2 mb-2">
                  {myDetails.Hotel_Master.address}{" "}
                  <span
                    className="text-decoration-underline text-success cursor-pointer"
                    onClick={() => mapHandler(myDetails.Hotel_Master.map)}
                  >
                    {" "}
                    see on map
                  </span>
                </p>
                <p className="blue-semi-12 m-0">Phone number</p>
                <p className="black-medium-12 m-0">
                  {myDetails.Hotel_Master.phonenumber}
                </p>
              </div>
            </div>
            <div>
              <h6>Booking Details</h6>
              <div className="hotel-details-main ">
                <div className="row">
                  <div className="col-lg-5">
                    <div>
                      <p className="blue-semi-12 m-0">Booking Number</p>
                      <p className="black-medium-12 m-0">
                        {myDetails.booking_number}
                      </p>
                    </div>
                  </div>
                  <div className="col-lg-5">
                    <p className="blue-semi-12 m-0">Booking Date</p>
                    <p className="black-medium-12 m-0">
                      {moment(myDetails.createdAt).format("MMMM Do YYYY")}
                    </p>
                  </div>
                  <div className="col-lg-5 mt-2">
                    <p className="blue-semi-12 m-0">Check in date</p>
                    <p className="black-medium-12 m-0">
                      {moment(myDetails.from_date).format("MMMM Do YYYY")}
                    </p>
                  </div>
                  <div className="col-lg-5 mt-2">
                    <p className="blue-semi-12 m-0">Check out</p>
                    <p className="black-medium-12 m-0">
                      {moment(myDetails.to_date).format("MMMM Do YYYY")}
                    </p>
                  </div>
                  <div className="col-lg-5 mt-2">
                    <p className="blue-semi-12 m-0">Check in time</p>
                    <p className="black-medium-12 m-0">
                      {myDetails.Hotel_Master.checkintime.split(":")[0] +
                        ":" +
                        myDetails.Hotel_Master.checkintime.split(":")[1]}
                      {/* {moment(myDetails.Hotel_Master.checkintime).format(
                        "HH:mm"
                      )} */}
                    </p>
                  </div>
                  <div className="col-lg-5 mt-2">
                    <p className="blue-semi-12 m-0">Check out time</p>
                    <p className="black-medium-12 m-0">
                      {myDetails.Hotel_Master.checkouttime.split(":")[0] +
                        ":" +
                        myDetails.Hotel_Master.checkouttime.split(":")[1]}
                      {/* {moment(myDetails.Hotel_Master.checkouttime).format(
                        "HH:mm"
                      )} */}
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div>
              <h6>Hotel Details</h6>
              <div className="hotel-details-main">
                <p className="blue-semi-12 m-0">
                  Total fare :{" "}
                  <span className="black-medium-12 m-0">
                    ${myDetails.total_fare}
                  </span>
                </p>
              </div>
            </div>
          </div>
          <div className="col-lg-6 col-md-6">
            <div>
              <h6>Room & Guest Details</h6>
              <div className="hotel-details-main">
                {myDetails?.Hotel_BookingDetails.map((ele, ind) => {
                  if (RoomType === undefined) {
                    RoomType = ele.room_number;
                  } else if (ele.room_number === RoomType) {
                    return (
                      <div className="room-guest-inner-description">
                        <p className="blue-semi-12 m-0">Guest {ind + 1} : </p>
                        <p className="black-medium-12 m-0">
                          {ele.customer_title} {ele.customer_first_name}{" "}
                          {ele.customer_last_name} ({ele.customer_type})
                        </p>
                      </div>
                    );
                  } else {
                    RoomType = ele.room_number;
                  }
                  return (
                    <>
                      <div className="room-guest-inner-description">
                        <p className="blue-semi-12 m-0">Room {i++}:</p>{" "}
                        <p className="black-medium-12 m-0">{ele.room_name}</p>
                      </div>

                      <div className="room-guest-inner-description">
                        <p className="blue-semi-12 m-0">Guest {ind + 1} : </p>
                        <p className="black-medium-12 m-0">
                          {ele.customer_title} {ele.customer_first_name}{" "}
                          {ele.customer_last_name} ({ele.customer_type})
                        </p>
                      </div>
                    </>
                  );
                })}
              </div>

              {/*
              <div>
                <button
                  className="cmn-btn cancel-req-btn"
                  onClick={() => {
                    
                    setShow(true);
                    setModalData(myDetails.booking_number);
                    setDeleting("hotel");
                  }}
                >
                  Request to Cancel
                </button>
              </div>
              */}
            </div>
          </div>
        </div>
        <div className="row cancellation-policy-main">
          <div className="col-lg-12">
            <h6>Cancellation Policy</h6>
          </div>
          {myDetails.BookingDetail !== undefined &&
            myDetails?.BookingDetail?.Rooms[0]?.CancelPolicies.map((ele) => {
              return (
                <div className={`col-lg-6 col-md-6`}>
                  <p
                    className={`${
                      ele.ChargeType === "Percentage"
                        ? "red-bg-text"
                        : "green-bg-text"
                    }`}
                  >
                    If You Cancel Before{" "}
                    {moment(ele.FromDate).format("MMMM Do YYYY")}
                    {/*  */}
                    Charge will be Applied{" "}
                    {ele.ChargeType === "Fixed" ? (
                      <span>
                        <i className="fa fa-dollar-sign"></i>
                        {ele.CancellationCharge}
                      </span>
                    ) : (
                      <span>{ele.CancellationCharge} %</span>
                    )}
                  </p>
                </div>
              );
            })}
          {/* <div className='col-lg-6'>
            <p className='green-bg-text'>
              Book today, lock the price. You can cancel until 05 November 2022
              and get a full refundof the transfer.
            </p>
          </div>
          <div className='col-lg-6'>
            <p className='red-bg-text'>
              Book today, lock the price. You can cancel from the 28 october
              2022 to 05 November 2022 and we’ll take $150.00 charges of the
              transfer.
            </p>
          </div> */}
        </div>
      </>
    );
  }
};

export default HotelDetail;
